import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-botanica-card bg-botanica-panel mt-20">
      <div className="max-w-6xl mx-auto px-5 py-12 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-lg bg-botanica-greenLight flex items-center justify-center">
              <Leaf className="w-4 h-4 text-botanica-green" />
            </span>
            <span className="font-serif text-lg font-semibold text-botanica-ink">Your Herbal Companion</span>
          </div>
          <p className="text-sm text-botanica-muted leading-relaxed">
            Your gentle herbal companion. Symptom-first, safe by default.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-botanica-ink mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-botanica-muted">
            <li><Link to="/library" className="hover:text-botanica-green transition-colors">Library</Link></li>
            <li><Link to="/recipes" className="hover:text-botanica-green transition-colors">Recipes</Link></li>
            <li><Link to="/kit" className="hover:text-botanica-green transition-colors">First Aid Kit</Link></li>
            <li><Link to="/favorites" className="hover:text-botanica-green transition-colors">Favorites</Link></li>
            <li><Link to="/ask" className="hover:text-botanica-green transition-colors">Ask Sage</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-botanica-ink mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-botanica-muted">
            <li><Link to="/about" className="hover:text-botanica-green transition-colors">About</Link></li>
            <li><Link to="/membership" className="hover:text-botanica-green transition-colors">Membership</Link></li>
            <li><span className="cursor-default">Privacy</span></li>
            <li><span className="cursor-default">Terms</span></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-botanica-ink mb-3">Stay well</h4>
          <p className="text-sm text-botanica-muted leading-relaxed mb-2">
            Educational only. Not medical advice. Always consult a qualified practitioner.
          </p>
        </div>
      </div>
      <div className="border-t border-botanica-card">
        <div className="max-w-6xl mx-auto px-5 py-5 text-xs text-botanica-muted flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Your Herbal Companion. Made with care for curious herbalists.</span>
          <span>Premium $1.99/mo — 7-day free trial</span>
        </div>
      </div>
    </footer>
  );
}
